(function () {
  if (customElements.get('product-gallery')) return;

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.galleryMain = this.querySelector('.product-gallery__main');
      this.mainImage = this.querySelector('.product-gallery__main-image');
      // Ursprüngliche Größenangabe merken: sie sagt dem Browser, welche
      // Variante er laden soll. Ohne sie lädt er immer die größte.
      this.mainSizes = this.mainImage ? this.mainImage.getAttribute('sizes') || '' : '';
      this.thumbsWrap = this.querySelector('.product-gallery__thumbs');
      this.thumbs = [].slice.call(this.querySelectorAll('.product-gallery__thumb'));

      this.allOptionValues = (this.dataset.allOptionValues || '')
        .split('|')
        .map((s) => s.trim())
        .filter(Boolean);

      // Welche Datenquelle ist überhaupt vorhanden? (sonst nicht filtern)
      this.variantIdsActive = this.thumbs.some(
        (t) => (t.dataset.variantIds || '').split(',').filter(Boolean).length > 0
      );
      this.altActive = this.thumbs.some((t) =>
        this.altHasAnyValue(t.dataset.imageAlt || '')
      );

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(thumb));
      });

      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.nav(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nav(1));

      this.setupSwipe();

      if (this.thumbsWrap) {
        this.thumbsWrap.addEventListener('scroll', () => this.updateFades(), { passive: true });
      }
      this.onResize = () => {
        this.updateFades();
        this.centerActive(false);
      };
      window.addEventListener('resize', this.onResize);

      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('variant:change', this.onVariantChange);

      // Initial nach gewählter Variante filtern (Hauptbild beibehalten)
      const initial = (this.dataset.selectedValues || '').split('|');
      const idInput = document.querySelector('input[name="id"]');
      this.filterByVariant(idInput ? idInput.value : null, null, true, initial);
      requestAnimationFrame(() => {
        this.updateFades();
        this.centerActive(false);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      window.removeEventListener('resize', this.onResize);
    }

    /* ---------- Galerie ---------- */

    // Weicher Rand: rechts/links einblenden, je nach Scroll-Position
    updateFades() {
      const el = this.thumbsWrap;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('is-fade-left', el.scrollLeft > 2);
      el.classList.toggle('is-fade-right', max > 2 && el.scrollLeft < max - 2);
    }

    // Aktives Thumbnail mittig in die Reihe scrollen
    centerActive(smooth) {
      const el = this.thumbsWrap;
      if (!el || el.hidden) return;
      const thumb = this.thumbs.filter(
        (t) => !t.hidden && t.classList.contains('is-active')
      )[0];
      if (!thumb) return;
      const elRect = el.getBoundingClientRect();
      const tRect = thumb.getBoundingClientRect();
      const delta = tRect.left + tRect.width / 2 - (elRect.left + elRect.width / 2);
      el.scrollBy({ left: delta, behavior: smooth ? 'smooth' : 'auto' });
    }

    // Aus einer Shopify-Bildadresse die passenden Breiten ableiten, damit der
    // Browser nicht jedes Mal die 1500-px-Fassung holen muss.
    srcsetFuer(url) {
      if (!/[?&]width=/.test(url)) return '';
      return [400, 600, 800, 1000, 1200, 1500]
        .map((w) => url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w')
        .join(', ');
    }

    setImage(full) {
      if (!this.mainImage || !full) return;
      const img = this.mainImage;
      const srcset = this.srcsetFuer(full);

      // Erst im Hintergrund laden und dekodieren, dann tauschen. So bleibt das
      // bisherige Bild stehen, statt für einen Moment zu verschwinden.
      const vorschau = new Image();
      if (this.mainSizes) vorschau.sizes = this.mainSizes;
      if (srcset) vorschau.srcset = srcset;
      vorschau.src = full;

      const tauschen = () => {
        if (srcset) {
          img.setAttribute('srcset', srcset);
          if (this.mainSizes) img.setAttribute('sizes', this.mainSizes);
        } else {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
        img.src = full;
      };

      if (vorschau.decode) {
        vorschau.decode().then(tauschen).catch(tauschen);
      } else if (vorschau.complete) {
        tauschen();
      } else {
        vorschau.onload = tauschen;
        vorschau.onerror = tauschen;
      }
    }

    // Nachbarbilder still im Hintergrund holen, damit der nächste Klick sitzt
    vorladen(thumb) {
      const sichtbar = this.thumbs.filter((t) => !t.hidden);
      const i = sichtbar.indexOf(thumb);
      if (i < 0) return;
      [sichtbar[i - 1], sichtbar[i + 1]].forEach((nachbar) => {
        if (!nachbar || !nachbar.dataset.full || nachbar.dataset.vorgeladen) return;
        nachbar.dataset.vorgeladen = '1';
        const bild = new Image();
        if (this.mainSizes) bild.sizes = this.mainSizes;
        const ss = this.srcsetFuer(nachbar.dataset.full);
        if (ss) bild.srcset = ss;
        bild.src = nachbar.dataset.full;
      });
    }

    select(thumb) {
      this.setImage(thumb.dataset.full);
      if (window.requestIdleCallback) {
        requestIdleCallback(() => this.vorladen(thumb));
      } else {
        setTimeout(() => this.vorladen(thumb), 300);
      }
      this.thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      this.centerActive(true);
    }

    // Touch-Swipe auf dem Hauptbild (Mobil) -> vorheriges/naechstes Bild
    setupSwipe() {
      const main = this.querySelector('.product-gallery__main');
      if (!main) return;
      let sx = 0;
      let sy = 0;
      let tracking = false;

      main.addEventListener(
        'touchstart',
        (e) => {
          if (e.touches.length !== 1) return;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      main.addEventListener(
        'touchend',
        (e) => {
          if (!tracking) return;
          tracking = false;
          const t = e.changedTouches[0];
          const dx = t.clientX - sx;
          const dy = t.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.nav(dx < 0 ? 1 : -1);
          }
        },
        { passive: true }
      );
    }

    // Pfeile: zum vorherigen/naechsten sichtbaren Bild
    nav(dir) {
      const visible = this.thumbs.filter((t) => !t.hidden);
      if (visible.length <= 1) return;
      let idx = visible.findIndex((t) => t.classList.contains('is-active'));
      if (idx === -1) idx = 0;
      idx = (idx + dir + visible.length) % visible.length;
      this.select(visible[idx]);
    }

    altHasAnyValue(alt) {
      return this.allOptionValues.some((v) => alt.indexOf(v) !== -1);
    }

    // Bild gehört zur Variante, wenn es ihr im Admin zugeordnet ist (variant_ids).
    matchVariantId(thumb, variantId) {
      if (!this.variantIdsActive) return true;
      const ids = (thumb.dataset.variantIds || '').split(',').filter(Boolean);
      return ids.length === 0 || ids.indexOf(String(variantId)) !== -1;
    }

    // Bild gehört zur Variante, wenn sein Alt-Text einen gewählten Optionswert
    // enthält. Bilder ohne erkennbaren Optionswert gelten als allgemein.
    matchAlt(thumb, selectedValues) {
      if (!this.altActive) return true;
      const alt = thumb.dataset.imageAlt || '';
      if (!this.altHasAnyValue(alt)) return true;
      return selectedValues.some((v) => v && alt.indexOf(v) !== -1);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      const selected = (variant.options || []).map((s) => String(s).toLowerCase());
      this.filterByVariant(variant.id, variant.featured_image, false, selected);
    }

    filterByVariant(variantId, featuredImage, keepMain, selectedValues) {
      if (this.thumbs.length === 0) return;
      const selected = (selectedValues || []).map((s) => String(s).toLowerCase());

      let visible = [];
      this.thumbs.forEach((thumb) => {
        const ok =
          this.matchVariantId(thumb, variantId) && this.matchAlt(thumb, selected);
        thumb.hidden = !ok;
        if (ok) visible.push(thumb);
      });

      // Fallback: passt nichts -> alle wieder anzeigen
      if (visible.length === 0) {
        this.thumbs.forEach((thumb) => {
          thumb.hidden = false;
        });
        visible = this.thumbs.slice();
      }

      // Thumbnail-Leiste + Pfeile ausblenden, wenn hoechstens 1 Bild uebrig bleibt
      const single = visible.length <= 1;
      if (this.thumbsWrap) this.thumbsWrap.hidden = single;
      if (this.prevBtn) this.prevBtn.hidden = single;
      if (this.nextBtn) this.nextBtn.hidden = single;

      let target;
      if (keepMain) {
        const currentSrc = this.mainImage ? this.mainImage.getAttribute('src') : null;
        target = visible.filter((t) => t.dataset.full === currentSrc)[0];
        if (!target) {
          target = visible[0];
          if (target) this.setImage(target.dataset.full);
        }
      } else if (featuredImage) {
        target = visible.filter((t) => t.dataset.full === featuredImage)[0] || visible[0];
        this.setImage(featuredImage);
      } else {
        target = visible[0];
        if (target) this.setImage(target.dataset.full);
      }

      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === target));
      this.updateFades();
      this.centerActive(!keepMain);
    }
  }

  customElements.define('product-gallery', ProductGallery);
})();
